import { api } from '../lib/apiClient';
import type { SaisieMembre } from '../components/ChampMembre';

/**
 * Applique la saisie : creer l'adhesion de l'annee, ou la retirer.
 *
 * `initial` doit venir de la MEME source que la pastille de la fiche
 * (`personne.adhesion_id`), et non d'un chargement propre au formulaire.
 * La version precedente lisait `useAdhesionCourante`, dont les requetes
 * partent dans un `useEffect` — donc APRES le rendu ou la modale s'ouvre.
 * La case s'initialisait a « ne cotise pas » pour les 46 membres actifs,
 * et l'enregistrement concluait a un retrait : ouvrir la fiche pour
 * corriger un telephone SUPPRIMAIT la cotisation, sans un mot.
 */
export async function enregistrerMembre(
  personneId: string,
  saisie: SaisieMembre,
  initial: { cotise: boolean; adhesionId: string | null },
  annee: { id: string; montantAdhesion: number } | null,
): Promise<void> {
  if (!annee || saisie.cotise === initial.cotise) return;

  if (saisie.cotise) {
    await api.post('/api/adhesions', {
      anneeId: annee.id,
      personneId,
      // RG-06 : le tarif vient de l'annee, il ne se ressaisit pas.
      montant: annee.montantAdhesion,
    });
  } else if (initial.adhesionId) {
    await api.delete(`/api/adhesions/${initial.adhesionId}`);
  }
}
